import { createClient } from '@supabase/supabase-js';

// Trong UmiJS, biến môi trường được truy cập thông qua process.env
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseKey) {
  console.error('⚠️ Supabase credentials not found in environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseKey);

/**
 * Hàm gọi Proxy API chung cho toàn bộ ứng dụng
 * Giúp giấu Service Role Key và xử lý dữ liệu an toàn trên Server
 */
export async function callProxy(body: {
  action: 'select' | 'update' | 'insert' | 'upsert' | 'delete' | 'rpc' | 'execute-tx';
  table?: string;
  data?: any;
  eqField?: string;
  eqValue?: any;
  select?: string;
  rpcName?: string;
  rpcArgs?: any;
  orderBy?: string;
  orderType?: 'asc' | 'desc';
  onConflict?: string;
}) {
  // Tại môi trường local, ta gọi đến /local-api (Umi Mock)
  // Tại môi trường production, Vercel sẽ xử lý /api
  const endpoint = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? '/local-api/supabase-admin'
    : '/api/supabase-admin';

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.error || 'API Proxy Error');
  }

  return response.json();
}
